/**
 * Odoo product/plan identifiers for BUENO EUROPE LTD (company_id 1, EUR).
 *
 * The API exposes no Odoo catalogue endpoint, so the ids that
 * `POST /api/Payments/odoo?productId=&planId=` expects are pinned here.
 * Only the Bueno Standard plans surfaced on the subscription page are wired up.
 */
export interface OdooPlanRef {
  productId: number;
  planId: number;
}

/** Bueno Standard (product 1) — Quaterly Plan, plan 2 / variant 15, €29.00. */
export const ODOO_STANDARD_QUARTERLY: OdooPlanRef = { productId: 15, planId: 2 };

/** Bueno Standard (product 1) — Annual Plan, plan 3 / variant 16, €99.00. */
export const ODOO_STANDARD_ANNUAL: OdooPlanRef = { productId: 16, planId: 3 };
